import { z } from "zod";

const environmentSchema = z.object({
  VITE_ZHATURA_API_ORIGIN: z.union([
    z.literal("SELF"),
    z.string().url().startsWith("https://"),
  ]),
  VITE_DEPLOYMENT_ENVIRONMENT: z.enum(["DEVELOPMENT", "STAGING", "PRODUCTION"]),
});

const rawOrigin: unknown = import.meta.env.VITE_ZHATURA_API_ORIGIN;
const rawEnvironment: unknown = import.meta.env.VITE_DEPLOYMENT_ENVIRONMENT;

const defaults =
  import.meta.env.MODE === "test" || import.meta.env.MODE === "development"
    ? {
        VITE_ZHATURA_API_ORIGIN:
          (typeof rawOrigin === "string" ? rawOrigin : undefined) ??
          "https://api.localhost",
        VITE_DEPLOYMENT_ENVIRONMENT:
          (typeof rawEnvironment === "string" ? rawEnvironment : undefined) ??
          "DEVELOPMENT",
      }
    : import.meta.env;

const parsed = environmentSchema.parse(defaults);

export const webEnvironment = {
  ...parsed,
  VITE_ZHATURA_API_ORIGIN:
    parsed.VITE_ZHATURA_API_ORIGIN === "SELF"
      ? window.location.origin
      : parsed.VITE_ZHATURA_API_ORIGIN,
};
